import React from 'react'
import CreateImgToLink from '../CreateImgToLink'

const X = () => {
    return (
        <div className='x-container'>
            <div className='x-header'>
                <h1> Twitter</h1>
                <CreateImgToLink />
            </div>
        </div>
    )
}

export default X